import React from 'react'
import  cup from '../assets/cup.png'

const Image = () => {
  return (
    <div>
        <img src={cup}
        alt='cups'
        className='w-full h-auto'/>
    </div>
  )
}

export default Image;